import { GET_ALL_PARENTS_SUCCESS } from '../actions/actionTypes';

export default function allParents(state = [], action) {
  switch (action.type) {
    case GET_ALL_PARENTS_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}
